enum CategoryIndexSearchMode {
	EXACT = 'exact',
	FROM = 'from',
	TO = 'to'
}
export default CategoryIndexSearchMode;
